<template>
    <div :class="{ 'tip': true, 'tip--compact': compact }">
        <div class="tip__wrapper" v-if="isActive">
            <div class="tip__item">?</div>
            <div class="tip__body">{{ getTipName(tipId) }}</div>
        </div>
    </div>
</template>

<script>
import tipsData from "@/utils/data/tips";

export default {
    data: () => ({
        tips: tipsData,
        isActive: false
    }),
    props: {
        tipId: {
            type: String
        },
        compact: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getTipName(id) {
            if (this.tips[id] !== undefined) {
                return this.tips[id];
            }
            return "";
        }
    },
    mounted() {
        if (this.getTipName(this.tipId)) {
            this.isActive = true;
        }
    }
};
</script>

<style lang="scss">
.tip {
    display: inline-block;
    vertical-align: top;
    margin-top: 20px;

    &--compact {
        margin-top: 0;
    }

    &__wrapper {
        height: 20px;
        width: 20px;
        position: relative;
        cursor: help;
    }

    &__item {
        color: #666;
        font-size: 1rem;
        font-weight: 700;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        vertical-align: middle;
        background: #eee;
        border-radius: 50%;
        // border: 2px solid #ccc;
    }

    &__body {
        opacity: 0;
        visibility: hidden;
        width: 222px;
        border: 1px solid #ddd;
        background: #fff;
        z-index: 10;
        border-radius: 4px;
        padding: 16px;
        position: absolute;
        right: -4px;
        top: 30px;
        font-size: 0.85rem;
        box-shadow: 0 0 16px #ccc;
        transition: all 0.3s ease;

        &::before {
            content: "";
            height: 16px;
            width: 16px;
            position: absolute;
            top: -9px;
            right: 5px;
            transform: rotate(45deg);
            background: #fff;
            border: 1px solid #ddd;
            border-width: 1px 0 0 1px;
            box-shadow: -3px -3px 5px #eee;
        }
    }

    &:hover {
        .tip__body {
            opacity: 1;
            visibility: visible;
        }
    }
}
</style>
